import type { ApplicationRecord, EventRecord, ProfileRecord } from '@romain130492/topchopsticks'

/**
 * VITE_DEV_MODE=true data.
 *
 * The same idea as the mini program's fixtures: the whole UI browsable with no
 * backend running, so layout and flow can be worked on offline — and so the
 * Profile page can actually be looked at without an SMS round trip.
 *
 * Dates are generated relative to now, so the feed always has genuine upcoming
 * AND past events and the "See past events" fold is never empty.
 */
const iso = (daysFromNow: number, hour: number) => {
  const d = new Date()
  d.setDate(d.getDate() + daysFromNow)
  d.setHours(hour, 0, 0, 0)
  return d.toISOString()
}

const event = (over: Partial<EventRecord>): EventRecord => ({
  id: 'x', event_type: 'social', source: 'curated', visibility: 'public', status: 'published',
  booking_mode: 'free', price: 0, currency: 'CNY', capacity: 6, seats_remaining: 3,
  languages: ['en', 'zh'],
  title: { en: 'Table', zh: '餐桌' },
  description: { en: 'A long table, good food, new people.', zh: '一张长桌，好菜，新朋友。' },
  address: { en: '20 Donghu Road, Xuhui', zh: '徐汇区东湖路20号' },
  price_label: { en: 'Free', zh: '免费' },
  cover_image_url: 'https://images.unsplash.com/photo-1552566626-52f8b828add9?w=800&q=60',
  ...over
})

export const fixtureEvents: EventRecord[] = [
  event({
    id: 'evt-1', start_at: iso(3, 19), end_at: iso(3, 22),
    title: { en: 'Sichuan, properly spicy', zh: '正宗川菜，够辣' }
  }),
  event({
    id: 'evt-2', source: 'curated', booking_mode: 'pay_later', price: 380, seats_remaining: 1,
    start_at: iso(6, 19), end_at: iso(6, 22),
    price_label: { en: '¥380 · pay at the table', zh: '¥380 · 到店支付' },
    title: { en: 'Cantonese tasting menu', zh: '粤式品鉴菜单' },
    cover_image_url: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800&q=60'
  }),
  event({
    id: 'evt-3', source: 'community', event_type: 'community',
    start_at: iso(9, 20), end_at: iso(9, 23),
    title: { en: 'Ramen crawl, Jing’an', zh: '静安拉面巡礼' },
    cover_image_url: 'https://images.unsplash.com/photo-1557872943-16a5ac26437e?w=800&q=60'
  }),
  event({
    id: 'evt-past', source: 'curated', seats_remaining: 0,
    start_at: iso(-8, 19), end_at: iso(-8, 22),
    title: { en: 'Yunnan mountain table', zh: '云南山地餐桌' },
    cover_image_url: 'https://images.unsplash.com/photo-1466637574441-749b8f19452f?w=800&q=60'
  })
]

export const fixtureProfile: ProfileRecord = {
  id: 'dev-profile',
  username: 'member_dev01',
  display_name: 'Dev Tester',
  phone_number: '13800138000',
  phone_country: '86',
  avatar_url: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&q=60',
  onboarding_phase: 'completed',
  language_preference: 'zh'
}

export const fixtureApplication: ApplicationRecord = {
  id: 'dev-application',
  status: 'submitted',
  completion_percentage: 100,
  answers: { looking_for: ['new_friends'], hobbies: ['food', 'music'], gender: 'female' }
}

export const fixtureAttendees = {
  total: 4,
  attendees: [
    { id: 'a1', avatar_url: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&q=60' },
    { id: 'a2', avatar_url: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&q=60' },
    { id: 'a3', avatar_url: null },
    { id: 'a4', avatar_url: 'https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?w=100&q=60' }
  ]
}
